import { Pagination, Skeleton } from '@mui/material';
import { PowerIcon, PowerOffIcon, Settings2Icon, UserRoundCogIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { checkTagValidity } from '../../Utils/Utils';
import { DELETE_USER, DISABLE_USER } from '../../Utils/constant';
import EditPenIcon from "../../assets/icons/pen.svg";
import TrashIcon from "../../assets/icons/trash.svg";
import { AddUser } from '../../components/utilisateur/AddUserSidebar';
import { EditPassword } from '../../components/utilisateur/EditPassword';
import { EditProfil } from '../../components/utilisateur/EditProfil';
import { EditUser } from '../../components/utilisateur/EditUser';
import { deleteOne, disable } from '../../services/service';
import { useRoleStore } from '../../store/RoleStore';
import { useStoreUser } from '../../store/user';

const Utilisateurs = () => {

  const users = useStoreUser()
  const role = useRoleStore()
  const loading = users.loading;
  const [selectItem, setSelectItem] = useState(null)

  useEffect(() => {
    users.user({ page: 0, param: "", size: 10 })
    role.getData('page=0&param=&size=8')

  }, [])

  const more = async (page) => {
    users.user({ page: page - 1, param: "", size: 10 })
  }

  const columns = [
    {
      name: "Nom et prenoms",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : row.nomPrenoms,
      sortable: true,
    },
    {
      name: "Nom d'utilisateur",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : row.username,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : row.email,
      sortable: true,
    },
    {
      name: "Numero telephone",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : row.numero,
    },
    {
      name: "Role",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : <p className={`text-xs  ${row?.enabled ? 'bg-green-100 text-green-800 font-semibold' : 'bg-rose-100 text-rose-800 font-semibold'}  rounded-lg px-2 py-1`}>{row?.roles[0] === "ROLE_ADMIN" ? "Admin" : row?.roles[0] === "ROLE_COMMERCIALE" ? 'Commerciale' : row?.roles[0] === "ROLE_TECHNICIEN" ? '' : 'DT'}</p>
    },
    {
      name: "Etat du compte",
      selector: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : <p className={`text-xs  ${row?.enabled ? 'bg-green-100 text-green-800 font-semibold' : 'bg-rose-100 text-rose-800 font-semibold'}  rounded-lg px-2 py-1`}>{row?.enabled ? 'Actif' : 'Inactif'}</p>
    },
    {
      name: "Action",
      cell: (row) => loading ? <Skeleton animation='wave' variant='text' width={80} />
        : (
          <div className="flex items-center gap-x-3">
            <div className="tooltip" data-tip="Modifier">
              <button onClick={() => {
                document.getElementById('add_user').showModal()
              }} className="w-7 h-7 rounded-lg bg-main flex items-center justify-center">
                <img src={EditPenIcon} alt="icon" className="w-4" />
              </button>
            </div>
            <div>
              <button onClick={() => {
                document.getElementById('disable').showModal()
              }} className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center" >
                <img src={TrashIcon} alt="icon" className="w-4" />
              </button>
            </div>
            <dialog id="disable" className="modal">
              <div className="modal-box max-w-md rounded-lg">
                <h3 className="font-extrabold text-xl text-red-600 ">
                  Attention
                </h3>
                <p className="pt-2 text-black font-medium">
                  Voulez vous vraiment effectuer cette action ?
                </p>
                <div className="modal-action">
                  <form
                    method="dialog"
                    className="w-full flex items-center justify-end gap-x-4"
                  >
                    <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                      Annuler
                    </button>
                    <button onClick={() => {
                      deleteOne(DELETE_USER, row.id).then((res) => {
                        toast.success('Utilisateur supprimé')
                      }).catch((err) => {

                      })
                    }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                      Désactiver
                    </button>
                  </form>
                </div>
              </div>
            </dialog>
          </div >
        ),
    },
  ];


  return (
    <>
      {
        checkTagValidity('LISTE_UTILISATEURS') ?
          <>
            <div className='flex item-center'>
              <h1 className="text-3xl font-mtn font-extrabold text-black">Utilisateurs</h1>
              <div className='ml-auto'>
                {
                  checkTagValidity('AJOUTER_UTILISATEUR') ?
                    <button onClick={() => document.getElementById('add_user').showModal()} className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                      Ajouter un utilisateur
                    </button>
                    : null
                }

                <dialog id="add_user" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-2xl">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold font-mtn'>Creation d'utilisateur</h1>
                      <form method="dialog">
                        <button
                          id="fermer-modal"
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>
                    <AddUser />
                  </div>
                </dialog>

                <dialog id="edit_user" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-2xl">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold font-mtn'>Modifier l'utilisateur</h1>
                      <form method="dialog">
                        <button
                          id={`fermer-modal${selectItem?.id}`}
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>
                    <EditUser item={selectItem} />
                  </div>
                </dialog>

                <dialog id="edit_password" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-xl">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold font-mtn'>Modifier le mot de passe de l'utilisateur</h1>
                      <form method="dialog">
                        <button
                          id={`fermer-modal${selectItem?.username}`}
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>
                    <EditPassword username={selectItem?.username} />
                  </div>
                </dialog>

                <dialog id="edit_profil" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-xl">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold font-mtn'>Modifier le profil</h1>
                      <form method="dialog">
                        <button
                          id={`fermer-profile${selectItem?.id}`}
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>

                    <EditProfil item={selectItem} />

                  </div>
                </dialog>
              </div>
            </div>

            <div className='mt-12 bg-white rounded-lg p-3 border border-[#f2f5fa] '>
              <div className='lg:flex gap-1 items-center'>
                <input onChange={(e) => {
                  users.user({ page: 0, param: e.target.value, size: 10 })
                }}
                  type="text" placeholder="Recherche..." className="input input-bordered px-3 my-2 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                />
                {/* <select onChange={(e) => {
                  users.user({ page: 0, param: e.target.value, size: 10 })
                }} className="my-2 select">
                  <option value="">
                    Tout
                  </option>
                  {
                    role?.data?.data?.map((item) => (
                      <option value={item.id}>
                        {item.id.replace("ROLE_", " ").toLowerCase()}
                      </option>
                    ))
                  }
                </select> */}
              </div>
              <div className="overflow-x-auto border rounded-lg mt-8">
                <table className="custom-table table font-mtn table-zebra">
                  {/* head */}
                  <thead className='bg-main text-black'>
                    <tr>
                      {
                        columns.map((item) => (
                          <th className='text-sm'>{item.name}</th>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      users?.data?.users?.length === 0 ? 'Aucune donnée' :
                        users?.data?.users?.length !== 0 && !loading ?
                          users?.data?.users?.map((item) => (
                            <tr>
                              <td>{item.nomPrenoms}</td>
                              <td>{item.username}</td>
                              <td>{item.email}</td>
                              <td>{item.numero}</td>
                              <th>
                                <p className={`text-xs w-fit ${item?.roles[0] === "ROLE_ADMIN" ? 'bg-green-100 text-green-800 font-semibold' : 'bg-rose-100 text-rose-800 font-semibold'}  rounded-lg px-2 py-1`}>{item?.roles[0]?.toLowerCase().replace(/role_/g, " ")}</p>
                              </th>
                              <td><p className={`text-xs w-fit ${item?.enabled ? 'bg-green-100 text-green-800 font-semibold' : 'bg-rose-100 text-rose-800 font-semibold'}  rounded-lg px-2 py-1`}>{item?.enabled ? 'Actif' : 'Inactif'}</p>
                              </td>
                              <td>
                                <div className="flex items-center gap-x-3">

                                  {
                                    checkTagValidity('MODIFIER_MOT_DE_PASSE') ?
                                      <div className="tooltip font-mtn" data-tip="Modifier le mot de passe">
                                        <button onClick={() => {
                                          setSelectItem(item)
                                          document.getElementById('edit_password').showModal()
                                        }} className="w-7 h-7 rounded-lg bg-main flex items-center justify-center">
                                          <UserRoundCogIcon size={15} />
                                        </button>
                                      </div>
                                      : null
                                  }

                                  <div className="tooltip" data-tip="Modifier">
                                    <button onClick={() => {
                                      setSelectItem(item)
                                      document.getElementById('edit_user').showModal()
                                    }} className="w-7 h-7 rounded-lg bg-main flex items-center justify-center">
                                      <img src={EditPenIcon} alt="icon" className="w-4" />
                                    </button>
                                  </div>
                                  <div>
                                    <button onClick={() => {
                                      document.getElementById('disable').showModal()
                                      setSelectItem(item)
                                    }} className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center" >
                                      {item?.enabled ? <PowerOffIcon size={14} /> : <PowerIcon size={14} />}
                                    </button>
                                  </div>

                                  <div className="tooltip font-mtn" data-tip="Editer le profil">
                                    <button onClick={() => {
                                      setSelectItem(item)
                                      document.getElementById('edit_profil').showModal()
                                    }} className="w-7 h-7 rounded-lg bg-main flex items-center justify-center">
                                      <Settings2Icon size={15} />
                                    </button>
                                  </div>

                                  <dialog id="disable" className="modal">
                                    <div className="modal-box max-w-md rounded-lg">
                                      <h3 className="font-extrabold text-xl text-red-600 ">
                                        Attention
                                      </h3>
                                      <p className="pt-2 text-black font-medium">
                                        Voulez vous vraiment effectuer cette action ?
                                      </p>
                                      <div className="modal-action">
                                        <form
                                          method="dialog"
                                          className="w-full flex items-center justify-end gap-x-4"
                                        >
                                          <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                            Annuler
                                          </button>
                                          <button onClick={() => {
                                            disable(DISABLE_USER, selectItem.id).then((res) => {
                                              toast.success(`Utilisateur ${selectItem?.enabled ? 'Désactiver' : 'Activer'}`)
                                              users.user({ page: 0, param: "", size: 10 })
                                            }).catch((err) => {

                                            })
                                          }} className="bg-black text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                            {selectItem?.enabled ? 'Désactiver' : 'Activer'}
                                          </button>
                                        </form>
                                      </div>
                                    </div>
                                  </dialog>

                                </div >
                              </td>
                            </tr>
                          )) :
                          (
                            [1, 2, 3, 4, 5].map((item) => (
                              <tr>
                                {
                                  [1, 2, 3, 4, 5, 6, 7].map(() => (
                                    <th><Skeleton height={13} /></th>
                                  ))
                                }
                              </tr>
                            ))
                          )
                    }

                  </tbody>
                </table>
              </div>

            </div>

          </> : null

      }
      {
        loading ? null :
          (
            <div className='my-3 flex justify-end'>
              <Pagination onChange={(event, newValue) => more(newValue)}
                onSelect={selectedPage => more(selectedPage)} count={users?.data?.totalPages} variant="outlined" color='primary' shape="rounded" />
            </div>
          )
      }
    </>
  )
}

export default Utilisateurs